var _a;
import { UnitSuffix } from '../../defs';
import { PICA_PIXEL_VALUE } from '../../internal/constants';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var picaToPixel = function (value) {
    return value * PICA_PIXEL_VALUE;
};
var picaToCentimeter = function (value) {
    return pixel.cm(picaToPixel(value));
};
var picaToMillimeter = function (value) {
    return pixel.mm(picaToPixel(value));
};
var picaToQuarter = function (value) {
    return pixel.Q(picaToPixel(value));
};
var picaToInch = function (value) {
    return pixel.in(picaToPixel(value));
};
var picaToPoint = function (value) {
    return pixel.pt(picaToPixel(value));
};
var picaToREM = function (value, options) {
    return pixel.rem(picaToPixel(value), options);
};
var picaToEM = function (value, options) {
    return pixel.em(picaToPixel(value), options);
};
var picaToViewWidth = function (value, options) {
    return pixel.vw(picaToPixel(value), options);
};
var picaToViewHeight = function (value, options) {
    return pixel.vh(picaToPixel(value), options);
};
var picaToViewMin = function (value, options) {
    return pixel.vmin(picaToPixel(value), options);
};
var picaToViewMax = function (value, options) {
    return pixel.vmax(picaToPixel(value), options);
};
export var pica = (_a = {},
    _a[UnitSuffix.Pixel] = picaToPixel,
    _a[UnitSuffix.Centimeter] = picaToCentimeter,
    _a[UnitSuffix.Millimeter] = picaToMillimeter,
    _a[UnitSuffix.Quarter] = picaToQuarter,
    _a[UnitSuffix.Inch] = picaToInch,
    _a[UnitSuffix.Pica] = noConvert,
    _a[UnitSuffix.Point] = picaToPoint,
    _a[UnitSuffix.REM] = picaToREM,
    _a[UnitSuffix.EM] = picaToEM,
    _a[UnitSuffix.ViewWidth] = picaToViewWidth,
    _a[UnitSuffix.ViewHeight] = picaToViewHeight,
    _a[UnitSuffix.ViewMin] = picaToViewMin,
    _a[UnitSuffix.ViewMax] = picaToViewMax,
    _a);
//# sourceMappingURL=pica.js.map